import React, { Component } from "react";
import { Row, Col, Tooltip } from "antd";
import Highlighter from "react-highlight-words";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { SecondaryButtonComponent } from "../../../../../../../CommonComponents/commonStyles";
import {
  LabelDataHeading,
  ValueDataHeading,
  ContentDivider,
  CharityHeading,
  Underlined
} from "../../../style";
import formatter from "../../../../../../../utils/formatter";
import { milliToDate, dateFormatter, recordError } from "../../../../../../../utils/commonUtil";
import PurposeSummary from "../../../../../Components/PurposeSummary/PurposeSummary";

export const renderAmount = text => {
  if (text !== "--") {
    return formatter({
      value: text,
      fieldSuffix: "Dollars"
    });
  } else {
    return text;
  }
};

class AgreementsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false
    };
    this.handlePop = this.handlePop.bind(this);
  }

  handlePop() {
    this.setState({ popup: !this.state.popup });
  }

  handleViewClick(id) {
    try {
      const location = {
        pathname: "/grants/grants-agreement/view",
        search: queryString.stringify({
          grantId: id
        })
      };
      this.props.history.push(location);
    } catch (error) {
      recordError(error);
    }
  }


  render() {
    const { data, search, agreementCTA, index } = this.props;
    let enteredDate = dateFormatter(data.gaStartDate);
    let endDate = dateFormatter(data.gaEndDate);    
    return (
      <div>
        {data && (
          <>
            <Row>
              <Col span={20}>
                <CharityHeading>
                  {data.charityName ? (
                    <Highlighter
                      id={`agreement-hightlighter-${index}`}
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[search]}
                      autoEscape={true}
                      textToHighlight={data.charityName && data.charityName.toString()}
                    />
                  ) : (
                    <>&mdash;</>
                  )}
                </CharityHeading>
              </Col>
              <Col span={4}>
                <ValueDataHeading>
                  {/* {data.isRecurring == "true" ? <img src={RecurringIcon} /> : null} */}
                </ValueDataHeading>
              </Col>
              <ContentDivider />
              <Col span={12}>
                <LabelDataHeading>Grant Term</LabelDataHeading>
                <ValueDataHeading>
                  {enteredDate === "Invalid date" &&
                  endDate === "Invalid date" ? (
                    <div>&mdash;</div>
                  ) : (
                    endDate + " - " + enteredDate
                  )}
                </ValueDataHeading>
              </Col>
              <Col span={12}>
                <LabelDataHeading>Total Agreement Amount</LabelDataHeading>
                <ValueDataHeading>
                  {renderAmount(data.grantAgreementAmount)}
                </ValueDataHeading>
              </Col>
            </Row>
            <ContentDivider />
            <Row>
              <Col span={12}>
                <LabelDataHeading>Purpose</LabelDataHeading>
                <Tooltip
                  placement="bottomRight"
                  title={<PurposeSummary {...data.purpose} />}
                  trigger="click"
                >
                  <Underlined>
                    {data.purpose ? data.purpose.description : <>&mdash;</>}
                  </Underlined>
                </Tooltip>
              </Col>
              <Col span={12}>
                <LabelDataHeading>
                  No. Of <br />
                  Payments
                </LabelDataHeading>
                <ValueDataHeading>
                  {data.noOfPayments > 9
                    ? data.noOfPayments
                    : "0" + data.noOfPayments}
                </ValueDataHeading>
              </Col>
            </Row>
            <ContentDivider />
            <Row>
              <Col span={12}>
                <LabelDataHeading>Status</LabelDataHeading>
                <ValueDataHeading>
                  {data.status && data.status.description}
                </ValueDataHeading>
              </Col>
             { agreementCTA && <Col span={8}>
                <SecondaryButtonComponent data-test="secondaryButton" onClick={() => this.handleViewClick(data.grantAgreementId)}
                >
                  View&nbsp;
                </SecondaryButtonComponent>
              </Col>}
            </Row>
          </>
        )}
      </div>
    );
  }
}


export default withRouter(AgreementsCard);